<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="fabricColorCode"
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :height="480"
      :loading="loading"
      :data="tableData"
      :columns="tableColumns"
      :cell-class-name="cellClassName"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div
          class="text-center d-flex align-items-center justify-content-center"
          style="cursor: pointer;"
          @click="$emit('check', row)"
        >
          <i
            class="el-icon-check"
            style="font-size: 19px; margin-right: 7px;"
          />
          <span>{{ $l('INDEX.evg_sku_label_choose') || '选择' }}</span>
        </div>
      </template>
      <template v-slot:displayImage="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width: 100px; height: 66px"
          fit="cover"
        >
          <div slot="error">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:displayName="{ row }">
        <span>{{ row.fabricName }}</span>
        <br />
        <span>{{ row.fabricNameEn }}</span>
        <br />
        <span>NO:</span><span>{{ row.fabricColorNo }}</span>
      </template>
      <template v-slot:displaySpec="{ row }">
        <span>{{ $l('table_label_wid') || '门幅' }}：</span>
        <span>{{ row.wid }} {{ row.v_widUnit }}</span>
        <br />
        <span>{{ $l('table_label_fabricWeight') || '克重' }}：</span>
        <span>{{ row.fabricWeight }} {{ row.v_fabricWeightUnit }}</span>
        <br />
        <span>{{ $l('table_label_fabricColorTitle') || '颜色' }}：</span>
        <span>{{ row.fabricColorTitle }} {{ row.fabricColorTitleEn }}</span>
      </template>
      <template v-slot:fabricContent="{ row }">
        <span>{{ row.fabricContent }}</span>
        <br />
        <span>{{ row.fabricContentEn }}</span>
      </template>
      <template v-slot:unitPrice="{ row }">
        <span>
          {{ row.unitPrice }}{{ $l('tbale_label_unitPriceUnit') || '元' }} /
          {{ row.v_fabricUnit }}
        </span>
      </template>
      <template v-slot:displayScm="{ row }">
        <span>{{ row.supName }}</span>
        <br />
        <span>{{ row.factoryNumber }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
export default {
  mixins: [EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    cellClassName({ column }) {
      return column.property === 'col-opt' ? '' : 'align-top'
    },
  },
}
</script>
